
export default function extractFileExt(file_str) {
    const splitString = file_str.split('.')
    if (splitString.length === 1) {
        return '';
    }
    return splitString[splitString.length-1]
}
